import { render, staticRenderFns } from "./scatteredorder.vue?vue&type=template&id=3f18828f&scoped=true"
import script from "./scatteredorder.vue?vue&type=script&lang=ts"
export * from "./scatteredorder.vue?vue&type=script&lang=ts"
import style0 from "./scatteredorder.vue?vue&type=style&index=0&id=3f18828f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f18828f",
  null
  
)

export default component.exports